import React from 'react';

import DateField from 'components/formInputs/DateField';
import SelectField from 'components/formInputs/SelectField';
import ToggleField from 'components/formInputs/ToggleField';
import FormWrapper from 'components/FormWrapper';
import ShowHide from 'components/ShowHide';
import { parseInteger } from 'forms/parsers';

import { DIASTOLIC_PRESSURE, LABELS, SYSTOLIC_PRESSURE } from './constants';
import { BloodPressureFormProps } from './types';

const BloodPressureForm: React.FC<BloodPressureFormProps> = ({
  handleSubmit,
  invalid,
  submitting,
  values,
}) => (
  <FormWrapper handleSubmit={handleSubmit} invalid={invalid} submitting={submitting}>
    <SelectField
      label={LABELS.systolicPressure}
      name="systolicPressure"
      options={SYSTOLIC_PRESSURE}
      config={{ parse: parseInteger }}
    />
    <SelectField
      label={LABELS.diastolicPressure}
      name="diastolicPressure"
      options={DIASTOLIC_PRESSURE}
      config={{ parse: parseInteger }}
    />
    <DateField label={LABELS.lastTreatedAt} name="lastTreatedAt" />
    <ToggleField groupLabel={LABELS.controlledWithMedication} name="controlledWithMedication" />
    <ShowHide visible={values.controlledWithMedication}>
      <DateField
        label={LABELS.controlledWithMedicationSince}
        name="controlledWithMedicationSince"
      />
    </ShowHide>
  </FormWrapper>
);

export default BloodPressureForm;
